module.exports = __webpack_public_path__ + "static/media/web-mockup.543f3410.png";